export default __webpack_public_path__ + "static/media/92.2387da50.jpg";